import React, { Component } from 'react';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import User from '../Entities/User';
import * as Sentry from '@sentry/browser';
import { errorAlert } from '../util/helperFunctions';

const defaultUser: FirebaseUser = {
  verified: false,
  loggedIn: false,
  email: '',
  admin: 'disabled',
};

const UserContext = React.createContext({
  user: new User(defaultUser),
  loading: false,
});

export class UserProvider extends Component {
  state = {
    user: new User(defaultUser),
    loading: true,
  };

  updateSentryUser = () => {
    const user = this.state.user;
    Sentry.configureScope(scope => {
      scope.setUser({ email: user.email });
    });
  };

  handleError = () => {
    errorAlert(
      '',
      `It looks like we're having some trouble connecting to the internet. Try refreshing the page. If this problem persists, please contact your supervisor.`
    );
  };

  componentDidMount() {
    const userRef = firebase.database().ref('/users');

    firebase.auth().onAuthStateChanged(user => {
      // when auth state changes run this....
      const userConfig = Object.assign({}, defaultUser);

      if (user !== null && user.email) {
        userConfig.email = user.email;
        userConfig.verified = user.emailVerified;
        userConfig.loggedIn = true;
        userRef
          .orderByChild('email')
          .equalTo(userConfig.email)
          .limitToFirst(1)
          .once(
            'value',
            res => {
              const fbUser: FirebaseUser = res.val();
              if (!fbUser || !Object.values(fbUser).length) {
                return;
              }

              userConfig.admin = Object.values(fbUser)[0].admin;
              this.setState(
                {
                  user: new User(userConfig),
                  loading: false,
                },
                () => this.updateSentryUser()
              );
            },
            this.handleError
          );
      } else {
        // if user NOT signed in, do this!
        this.setState(
          {
            user: new User(userConfig),
            loading: false,
          },
          () => this.updateSentryUser()
        );
      }
    }, this.handleError);
  }

  render() {
    const { children } = this.props;

    return (
      <UserContext.Provider value={this.state}>{children}</UserContext.Provider>
    );
  }
}

export const UserContextConsumer = UserContext.Consumer;
